import React from "react";

import FeaturedProjectsPage from "components/ProjectsList/FeaturedProjectsPage";

import localize from "lang/localize";

class LosDesafiosFeaturedProjectsPage extends FeaturedProjectsPage {
  render() {
    return (
      <div className="projects-list container verticalpadding">
        {/* custom: removed header / title */}
        <div>
          {this.renderProjects()}
          {this.props.more && (
            <div className="innerblock project-cards-wrapper">
              <div className="more-button-container">
                <button
                  className="button automargin"
                  onClick={this.props.handleMore}
                >
                  {localize("more_text", this.props.language)}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default LosDesafiosFeaturedProjectsPage;
